import { useLayoutEffect } from 'react';
import { useQuery } from 'react-query';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';
import * as errorReporting from 'hb-react/shared/utils/errorReporting';

const fetchMenuItems = () =>
  axios
    .get(Routes.menu_items_path({ format: 'json' }))
    .then(({ data: { menu_items: appPages } }) => appPages)
    .catch((err) => {
      errorReporting.captureException(err);
    });

const useFetchAppPages = ({ enabled = true } = {}) => {
  const { currentNetwork, updateCurrentNetwork } = useDefaultAppContexts();
  const hasInitialData = !!currentNetwork?.app_pages;

  const { data } = useQuery({
    queryKey: ['appPages'],
    queryFn: fetchMenuItems,
    initialData: currentNetwork?.app_pages ?? null,
    enabled: !hasInitialData && enabled,
    staleTime: hasInitialData ? 15 * 60 * 1000 : 0, // 15 minutes of stale once the initial data are set in currentNetwork
  });

  useLayoutEffect(() => {
    if (!hasInitialData && data) {
      if (window.AlumniConnect?.currentNetwork) {
        AlumniConnect.currentNetwork = {
          ...AlumniConnect.currentNetwork,
          app_pages: data,
        };
      }

      // Update currentNetwork context
      updateCurrentNetwork({
        app_pages: data,
      });
    }
  }, [data, hasInitialData, updateCurrentNetwork]);

  return data;
};

export default useFetchAppPages;
